export const getStaticAssetPath = (path: string) => {
  const baseUrl = process.env.PUBLIC_URL || '';
  return `${baseUrl}${path}`;
}; 